import ActionsForm from '@/shared/mixins/actionsForm'
import ImportSearchForm from './search-form.js'
import Tools from '@/components/tools/Tools'

const ImportSearchModel = {
  statusImport: null,
  tipoPlanilha: null
}

export default {
  mixins: [ActionsForm],
  name: 'ImportSearch',
  data () {
    return {
      data: ImportSearchModel,
      form: ImportSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  beforeDestroy () {
    this.onClearOptions()
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearOptions () {
      this.form.tipoPlanilha.value = null
      this.form.statusImport.value = null
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.onClearOptions()
      this.parentComponent.filters = null
      this.parentComponent.onLoadAll()
    },
    onValidateFilters () {
      let result = true
      Tools.SetValueToSave(this.form, this.data)
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/import/components/search/search.js